import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Button, Container, Input, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import ChatBot from './Chatbot';
// import PDFTab from './Demo1';

const Chat = () => {


    return (
        <React.Fragment>
            <div className='page-content'>
                <Container fluid>
                    <Col>
                        <BreadCrumb title="Chat Bot"  pageTitle="Dashboard"/>
                        <Card>
                            <CardBody>
                                <Row>
                                    {/* <PDFTab /> */}
                                    <ChatBot />
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Chat;
